import { render, staticRenderFns } from "./unionGoodsListForMember.vue?vue&type=template&id=3fba3e46&scoped=true&"
import script from "./unionGoodsListForMember.vue?vue&type=script&lang=js&"
export * from "./unionGoodsListForMember.vue?vue&type=script&lang=js&"
import style0 from "./unionGoodsListForMember.vue?vue&type=style&index=0&id=3fba3e46&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fba3e46",
  null
  
)

component.options.__file = "unionGoodsListForMember.vue"
export default component.exports